import TriggerConfigSerializer from 'eflex/serializers/trigger-config';

export default class AudioTriggerConfigSerializer extends TriggerConfigSerializer {}
